import { Inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import {
  IPermissions,
  ModulesMangosI,
} from '../../interfaces/modules-mango.interface';
import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { InfoTokenService } from '../infoUser/info-user.service';
import { RolesUserService } from '../roles-user/roles-user.service';
import { IPkSk } from '../../interfaces/versions.interface';
import { IUser } from '../../interfaces/toolbar/toolbar.interface';
import { IDataUser } from '../../interfaces/user.interface';
const jwt = new JwtHelperService();

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  public url = '';
  public idsModule!: IPkSk;

  constructor(
    private infoUser: InfoTokenService,
    private router: Router,
    private http: HttpClient,
    private roleUserService: RolesUserService,
    @Inject(DOCUMENT) document: any
  ) {}

  getInfoRoles(url: string) {
    return new Promise<IPermissions>((resolve, reject) => {
      const data = this.infoUser.getDataToken();
      this.http
        .get(`${url}/users/resources/${data?.username}`)
        .subscribe((resp: any) => {
          const roles: IPermissions = resp;
          resolve(roles);
        });
    });
  }

  getModules(url: string) {
    return new Promise<ModulesMangosI[]>((resolve, reject) => {
      this.http.get(`${url}/clients/modules`).subscribe((resp: any) => {
        const modules: ModulesMangosI[] = resp.data;
        resolve(modules);
      });
    });
  }

  setUrl(url: string) {
    this.url = url;
  }

  setIdsModule(ids: IPkSk) {
    this.idsModule = ids;
  }

  getUser(url: string, pk: string, sk: string) {
    return this.http.get<IDataUser>(`${url}/users/${pk}/${sk}`);
  }

  updatetUser(url: string, pk: string, sk: string, user: IUser) {
    return this.http.patch<IUser>(`${url}/users/${pk}/${sk}`, user);
  }

  refreshToken(pk: string, sk: string, refreshToken: string) {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${refreshToken}`
    );
    return this.http.get<any>(`${this.url}/token/${pk}/${sk}/refresh`, {
      headers,
    });
  }

  getInfoVersion(version: string, pk: string, sk: string) {
    return this.http.get<any>(
      `${this.url}/system-modules/${pk}/${sk}/versions/${version}:current`
    );
  }
  /**
   * Logout
   */
  logout(): void {
    this.infoUser.removeToken();
    this.roleUserService.resetPermissions();
    this.router.navigate(['/login']);
  }
}
